import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { testPersonalities, TestPersonnalityModel } from 'src/app/model/test-personnality';
import { UtilisateursService } from 'src/app/modules/utilisateurs/services/utilisateurs.service';

@Component({
  selector: 'app-test-personnality',
  templateUrl: './test-personnality.component.html',
  styleUrls: ['./test-personnality.component.css'],
})
export class TestPersonnalityComponent implements OnInit {
  profilTest: TestPersonnalityModel[] = testPersonalities;
  isDisable=true;
  isNotValid: boolean = false;
  recupCodeTest!: any;
  // MycodeTest="INTJ-A / INTJ-T"
  recupIuf!: any;
  recupTestData: any = null;
  user!: any;
  form!: FormGroup;

  showValided: boolean = true;
  showTest: boolean = false;

  constructor(
    private utilisateurService: UtilisateursService,
    private formBuilder: FormBuilder
  ) {
    this.user = sessionStorage.getItem('user');
    // //console.log("user :",JSON.parse(this.user) );
    this.recupIuf = JSON.parse(this.user).iuf;
  }
  ngOnInit(): void {
    this.initForm();
    this.initTestPersonnalite();
  }

  verify() {
    this.isDisable = this.form.get('selectedCode')?.value =='';
  }

  initForm() {
    this.form = this.formBuilder.group({
      selectedCode: ['', Validators.required],
      nomProfil: [''],
      baseLine: [''],
      imageurl: [''],
    });
  }

  onSaveTestPersonnality(iuf: string): void {
    const testCode = this.form.get('selectedCode')?.value;
    if (!this.profilTest.some((p) => p.code_test === testCode)) {
      this.isNotValid = true;
      return;
    }
    // //console.log("IUF :",iuf)
    this.utilisateurService.saveTestPersonnality(testCode, iuf).subscribe(
      (response) => {
        // //console.log('Succès de la sauvegarde du profil de test:', response);

        this.getDataTestPersonnality(testCode);
      },
      (error) => {
        console.error('Erreur lors de la sauvegarde du profil de test:', error);
      }
    );
  }

  getDataTestPersonnality(codeTest: string): void {
    this.utilisateurService.getDataTestPersonnality(codeTest).subscribe(
      (data) => {
        this.recupTestData = data;
        if (this.recupTestData.baseline == null) {
          this.showValided = true;
          this.showTest = false;
        } else {
          this.showValided = false;
          this.showTest = true;
        }
        // //console.log("Données du test récupérées :", this.recupTestData);

        this.form.patchValue({
          nomProfil: this.recupTestData.nomProfil,
          baseLine: this.recupTestData.baseline,
          imageurl: this.recupTestData.imageUrl,
        });
      },
      (error) => {
        console.error(
          'Erreur lors de la récupération des données du profil de test:',
          error
        );
      }
    );
  }

  initTestPersonnalite() {
    this.utilisateurService
      .getExistingDataByIuf(this.recupIuf)
      .subscribe((data) => {
        this.recupTestData = data;
        // //console.log("Données du test récupérées :", this.recupTestData);

        if (this.recupTestData.baseline == null) {
          this.showValided = true;
          this.showTest = false;
        } else {
          this.showValided = false;
          this.showTest = true;
        }
        this.form.patchValue({
          nomProfil: this.recupTestData.nomProfil,
          baseLine: this.recupTestData.baseline,
          imageurl: this.recupTestData.imageUrl,
        });
      });
  }
}
